import { loadTranslation } from "@lib/utils";
import { GetStaticProps } from "next";
import Term from "./pdpa";

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const translation = await loadTranslation(
    locale,
    process.env.NODE_ENV == "production"
  );

  return { props: { translation } };
};

export default Term;
